// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar_Avatar__hGuL7","Initials":"Avatar_Initials__+84C2"};